/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {IDirectPayIpgConfig as ɵa} from './lib/direct-pay-ipg.config';